const getCryptoObj = () => {
    return window.crypto || window.msCrypto;
};
export const getCamelRandomId = (kind, length = 4) => {
    var _a, _b;
    const randomNumber = Math.floor((_b = (_a = getCryptoObj()) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint32Array(1))[0]) !== null && _b !== void 0 ? _b : Date.now());
    return `${kind}-${randomNumber.toString(10).slice(0, length)}`;
};
export const getHexaDecimalRandomId = (prefix) => {
    var _a, _b;
    const randomNumber = (_b = (_a = getCryptoObj()) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint32Array(1))[0]) !== null && _b !== void 0 ? _b : Date.now();
    return `${prefix}-${randomNumber.toString(16)}`;
};
//# sourceMappingURL=camel-random-id.js.map